import {Component, Vue, Prop} from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import PerformanceProgress from '@/components/charts/performance-bar/performance-bar';
import DountChart from '@/components/charts/dount-chart/dount-chart';

@Component({
    name: 'avg-session-popup',
    components: {
        'material-icon': GoogleMaterialIcon,
        'performance-bar': PerformanceProgress,
        'dount-chart': DountChart,
    },
})

export default class AvgSessionPopup extends Vue {

    private itrate: any = [{
        name: 'ABC Unified',
        time: '50m',
        performance: ['10%', '30%', '20%', '20%'],
    },
    {
        name: 'Acalanes Union High',
        time: '50m',
        performance: ['20%', '10%', '30%', '20%'],
    }, {
        name: 'Ackerman Charter',
        time: '30m',
        performance: ['20%', '20%', '20%', '20%'],
    },
    {
        name: 'Acton-Agua Dulce Unified',
        time: '40m',
        performance: ['30%', '20%', '10%', '20%'],
    },
    {
        name: 'Adelanto Elementary',
        time: '20m',
        performance: ['30%', '10%', '20%', '20%'],
    }, {
        name: 'Alameda County Office Of Education',
        time: '10m',
        performance: ['30%', '32%', '20%', '10%'],
    },
    {
        name: 'Alameda Unified',
        time: '14m',
        performance: ['30%', '10%', '30%', '10%'],
    },
    {
        name: 'Albany City Unified',
        time: '23m',
        performance: ['10%', '20%', '30%', '20%'],
    },
    // {
    //     name: 'Alexander Valley Union Elementary',
    //     time: '2h',
    //     performance: ['20%', '20%', '20%', '20%'],
    // },
    // {
    //     name: 'Alhambra Unified',
    //     time: '5h',
    //     performance: ['20%', '10%', '40%', '20%'],
    // },
    // {
    //     name: 'Alisal Union',
    //     time: '3h',
    //     performance: ['30%', '10%', '20%', '20%'],
    // },
];

    private data: any = [{
        name: 'chart',
        value: 530,
        color: '#febb2b',
    },
    {
        name: 'chart1',
        value: 300,
        color: '#ebeced',
    },
    ];

    private data1: any = [{
        name: 'chart',
        value: 530,
        color: '#0a66ba',
    },
    {
        name: 'chart1',
        value: 300,
        color: '#ebeced',
    },
    {
        name: 'chart2',
        value: 400,
        color: '#7ccff7',
    },
    ];

    private dataList?: any = [];

    private isShowMessage: boolean = false;

    private messageBoxStyle?: any = null;

    private get level() {
        return this.dataList[0].sub_type;
    }

    private get countryName() {
        return this.$route.params.name;
    }

    @Prop()
    private cardValue: any;

    // -----------------------------------------------------------------------
    // Actions

    private onGoBack() {
        this.$emit('onGoBack', false);
    }

    private onShowMessage(event: any, index: any = 0) {
        this.isShowMessage = true;
        this.messageBoxStyle = {
            top: (event.pageY - 255) + 'px',
            left: (event.pageX - 150) + 'px',
        };
    }

    private onHideMessage() {
        this.isShowMessage = false;
    }

    // ------------------------------------------------------------------------
    // Hooks
    private created() {
        window.scrollTo(0, 0);
   }


    // --------------------------------------------------------------------------
    // Methods

}
